import React from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import { logInSuccessFollowUp } from './actions/authenticationActions';
import UserAccountManagementClient from './components/UserAccountManagementClient';
import { store } from './store';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((loadedUser) => {
  if (loadedUser) store.dispatch(logInSuccessFollowUp(loadedUser));
});

const root = createRoot(document.querySelector('.root')!);
root.render(<UserAccountManagementClient reduxStore={store} />);
